import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { gsap, Power0 } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

import { Controller, Scene } from "react-scrollmagic";
import { useWindowSize } from "react-use";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../firstComp/firstComp.css";
import Slider from "react-slick";

// images
import img1 from "../../../images/secondComp/slider/img1.webp";
import img2 from "../../../images/secondComp/slider/img2.webp";
import img3 from "../../../images/secondComp/slider/img3.webp";
import img4 from "../../../images/secondComp/slider/img4.webp";
import prod1 from "../../../images/secondComp/prod1.webp";
import prod2 from "../../../images/secondComp/prod2.webp";
import prod3 from "../../../images/secondComp/prod3.webp";
import prod4 from "../../../images/secondComp/prod4.webp";
import prod5 from "../../../images/secondComp/prod5.webp";
import bgSvg from "../../../images/secondComp/bgSvg.svg";
import flakes from "../../../images/secondComp/flakes.svg";
import video from "../../../videos/vid3.mp4";
import star from "../../../images/secondComp/star.svg";
import video2 from "../../../videos/vid2.mp4";
import "./secondComp.css";

export default function SecondComp() {
  const settings = {
    touchThreshold: 200,
    dots: false,
    autoplay: true,

    autoplaySpeed: 0,
    // cssEase: "linear",
    slidesToShow: 1,
    initialSlide: 0,
    accessibility: false,
    infinite: true,
    speed: 3000,
    dotsClass: "colavo-carousel-dots",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "50px"
        }
      }
    ]
  };
  const settingsProducts = {
    touchThreshold: 200,
    dots: false,
    slidesToShow: 1.5,
    initialSlide: 0,
    accessibility: false,
    infinite: false,
    speed: 500,
    dotsClass: "colavo-carousel-dots",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          centerPadding: "50px"
        }
      }
    ]
  };
  gsap.registerPlugin(ScrollToPlugin);
  let starRef = useRef(null);
  let flakeRef = useRef(null);
  let trigger = useRef(null);
  useEffect(() => {
    // gsap.set(flakeRef, {
    //   y: -200
    // });
    gsap.set(starRef, {
      // autoAlpha: 0.2
      // scale: 0.7
    });
  });
  useEffect(() => {
    gsap.to(starRef, {
      rotation: "360",
      duration: 12,
      ease: "none",
      // autoAlpha: 0.6,
      repeat: -1
      // scale: 1.0
      // onComplete: {
      //   rotation: "360",
      //   duration: 12,
      //   autoAlpha: 0.2,
      //   scale: 0.7
      // }
    });
  });

  // useEffect(() => {
  //   gsap.to(flakeRef, {
  //     y: 200,
  //     duration: 16,
  //     ease: "none",
  //     repeat: -1,
  //     scrollTrigger: {
  //       start: "bottom bottom",
  //       end: "bottom",
  //       trigger: trigger,
  //       toggleActions: "play none none reverse"
  //     }
  //   });
  // });

  return (
    <div className="secondComp-main">
      <div className="gradient" />
      <div className="desk-secondComp-main-wrap">
        <div className="vid-wrap second-vid-wrap">
          <video
            playsinline="true"
            autoplay="true"
            loop="true"
            muted="true"
            className="video-scroll"
          >
            <source src={video2} type="video/mp4 " />
          </video>
          <div className="scroll-filter second-scroll-filter" />
        </div>

        <div className="secondComp-header">
          <div>X</div>
          <div>THE MAS</div>
          <div>COLLECTION</div>
          <img className="star-img" src={star} ref={(el) => (starRef = el)} />
        </div>

        <div className="ContentRow2">
          <div className="shopComp-container">
            <div className="shopComp-element shopComp-product-1">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.teilor.hu/product/126436/18K-feh%C3%A9rarany-f%C3%BClbeval%C3%B3-1.98ct-gy%C3%A9m%C3%A1ntokkal"
              >
                <img className="zoom" alt="" src='https://cdn.media.amplience.net/i/teilor/212654_WHITE_1'></img>
                <div className="itemDetails">
                  <div>
                    <b>
                      CHANDELIER <br /> EARRINGS
                    </b>
                  </div>
                  <div>
                  18k Fehér arany
                    <div className="mobile-txt-bg" />
                  </div>
                </div>
              </a>
            </div>
            <div className="shopComp-element shopComp-product-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.teilor.hu/product/107659/18K-feh%C3%A9rarany-gy%C5%B1r%C5%B1-1.19ct-gy%C3%A9m%C3%A1ntokkal"
              >
                <img className="zoom" alt="" src={'https://cdn.media.amplience.net/i/teilor/204204_WHITE_1'}></img>
                <div className="itemDetails">
                  <div>
                    <b>
                      SQUARE <br /> RING
                    </b>
                  </div>
                  <div>
                  18k Fehér arany
                    <div className="mobile-txt-bg" />
                  </div>
                </div>
              </a>
            </div>
            <div className="shopComp-element shopComp-product-3">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.teilor.hu/product/111244/18K-feh%C3%A9rarany-f%C3%BClbeval%C3%B3-2.84ct-gy%C3%A9m%C3%A1ntokkal"
              >
                <img className="zoom" alt="" src={'https://cdn.media.amplience.net/i/teilor/205658_WHITE_1'}></img>
                <div className="itemDetails details-prod-3">
                  <div>
                    <b>
                      ETERNITY <br />
                      EARRINGS
                    </b>
                  </div>
                  <div>
                  18k Fehér arany
                    <div className="mobile-txt-bg" />
                  </div>
                </div>
              </a>
            </div>
            <div className="shopComp-element shopComp-product-4">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.teilor.hu/product/54013/Gy%C5%B1r%C5%B1-18K-os-feh%C3%A9r-aranyb%C3%B3l-1ct-gy%C3%A9m%C3%A1nttal.-Gramm:-1,80"
              >
                <img className="zoom" alt="" src={'https://cdn.media.amplience.net/i/teilor/44573_WHITE_1'}></img>
                <div className="itemDetails">
                  <div>
                    <b>
                      FOREVER <br /> RING
                    </b>
                  </div>
                  <div>
                  18k Fehér arany
                    <div className="mobile-txt-bg" />
                  </div>
                </div>
              </a>
            </div>
            <div className="shopComp-element shopComp-product-5">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.teilor.hu/product/118929/F%C3%BClbeval%C3%B3-18K-os-feh%C3%A9r-aranyb%C3%B3l-2.77ct-gy%C3%A9m%C3%A1nttal"
              >
                <img className="zoom" alt="" src={'https://cdn.media.amplience.net/i/teilor/208758_WHITE_1'}></img>
                <div className="itemDetails">
                  <div>
                    <b>
                      RED CARPET <br />
                      EARRINGS
                    </b>
                  </div>
                  <div>
                  18k Fehér arany
                    <div className="mobile-txt-bg" />
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className="snd-comp-btn">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.teilor.hu/pure-diamonds"
            >
              Fedezd fel a kollekciót
              <div className="mobile-txt-bg" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
